export enum NGridFilterMethod {
    ColumnFilter,
    FreeTextSearch
}
